import React from 'react';

const combineProvider =
    (providers: React.ComponentType<{ children: React.ReactNode }>[]) =>
    ({ children }: { children: React.ReactNode }): React.ReactElement =>
        providers.reverse().reduce(
            (tree, Provider) => <Provider>{tree}</Provider>,
            children as React.ReactElement
        );
export default combineProvider;

